import { useState } from 'react';
import { useController } from 'react-hook-form';
import { Box, Chip, Stack, TextField, Typography } from '@mui/material';

export const OptionsChipInput = () => {
    const { field } = useController({ name: 'options', defaultValue: [] });
    const [inputValue, setInputValue] = useState('');

    const addOption = () => {
        const trimmed = inputValue.trim();
        if (!trimmed) return;
        field.onChange([...(field.value || []), { display_name: trimmed }]);
        setInputValue('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addOption();
        }
    };

    const handleDelete = (index) => {
        field.onChange((field.value || []).filter((_, i) => i !== index));
    };

    return (
        <Box sx={{ width: '50%', mt: 1 }}>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                Opciones
            </Typography>
            <TextField
                label="Nueva opción (Enter para añadir)"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={addOption}
                size="small"
                fullWidth
            />
            {(field.value || []).length > 0 && (
                <Stack direction="row" flexWrap="wrap" gap={1} mt={1.5}>
                    {(field.value || []).map((option, index) => (
                        <Chip
                            key={option.id ?? index}
                            label={option.display_name}
                            onDelete={() => handleDelete(index)}
                            size="small"
                        />
                    ))}
                </Stack>
            )}
        </Box>
    );
};
